﻿<!-- ── Modal Header ── -->
<div class="rs-modal-header">
  <div class="rs-header-icon-box">
    <ion-icon name="chatbox-ellipses-outline"></ion-icon>
  </div>
  <div class="rs-header-copy">
    <span class="rs-header-kicker">Tele Calling</span>
    <h2 class="rs-header-title">Save Response</h2>
  </div>
  <button class="rs-close-btn" (click)="cancel()" aria-label="Close dialog">
    <ion-icon name="close-outline"></ion-icon>
  </button>
</div>

<!-- ── Body ── -->
<mat-dialog-content class="rs-dialog-body">

  <!-- Hint -->
  <!-- <div class="rs-hint-row">
    <ion-icon name="information-circle-outline"></ion-icon>
    <span>Select one or more outcomes for this call</span>
  </div> -->

  <!-- Search -->
  <div class="rs-search-wrap">
    <div class="rs-search-icon-box">
      <ion-icon name="search-outline"></ion-icon>
    </div>
    <input
      class="rs-search-input"
      type="text"
      [(ngModel)]="searchResponseText"
      placeholder="Search response…"
      autocomplete="off" />
    @if (searchResponseText) {
    <button class="rs-search-clear" (click)="searchResponseText = ''" aria-label="Clear search">
      <ion-icon name="close-circle"></ion-icon>
    </button>
    }
  </div>

  <!-- Response List -->
  <div class="rs-response-list">
    @if (filteredResponseList.length === 0 && searchResponseText) {
    <div class="rs-no-results">
      <ion-icon name="search-outline"></ion-icon>
      <span>No results for "{{ searchResponseText }}"</span>
    </div>
    }
    @for (item of filteredResponseList; track $index) {
    <div class="rs-response-item" [class.rs-item--selected]="isChecked(item.name)"
      (click)="onCheckboxChange(item.name, { detail: { checked: !isChecked(item.name) } })"
      role="checkbox" [attr.aria-checked]="isChecked(item.name)" tabindex="0"
      (keydown.space)="onCheckboxChange(item.name, { detail: { checked: !isChecked(item.name) } })">

      <div class="rs-item-icon-box">
        <ion-icon [name]="isChecked(item.name) ? 'checkmark-circle' : 'ellipse-outline'"></ion-icon>
      </div>

      <span class="rs-item-label">{{ item.name }}</span>

      <ion-checkbox
        class="rs-item-checkbox"
        [checked]="isChecked(item.name)"
        (ionChange)="onCheckboxChange(item.name, $event)"
        (click)="$event.stopPropagation()">
      </ion-checkbox>
    </div>
    }
  </div>

</mat-dialog-content>

<!-- ── Footer ── -->
<div class="rs-dialog-footer">
  <div class="rs-custom-list-pill" (click)="goToCustomActivites('Calling')" role="button" tabindex="0"
    (keydown.enter)="goToCustomActivites('Calling')">
    <ion-icon name="apps-outline"></ion-icon>
    <span>Custom List</span>
  </div>
  <div class="rs-footer-actions">
    <ion-button fill="outline" class="rs-btn-cancel" (click)="cancel()">
      <ion-icon name="close-circle-outline" slot="start"></ion-icon>
      Close
    </ion-button>
    <ion-button class="rs-btn-save" [disabled]="selectedValueResponse.length === 0" (click)="save()">
      <ion-icon name="save-outline" slot="start"></ion-icon>
      Save
    </ion-button>
  </div>
</div>

<style>
  /* ── Header ─────────────────────────────────────────────── */
  .rs-modal-header {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 18px 20px 16px;
    background: linear-gradient(145deg, var(--ion-color-secondary-shade) 0%, #2d4f96 100%);
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  }

  .rs-header-icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.22);
    flex-shrink: 0;
  }

  .rs-header-icon-box ion-icon {
    font-size: 22px;
    color: #fff;
  }

  .rs-header-copy {
    flex: 1;
    min-width: 0;
  }

  .rs-header-kicker {
    display: block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.65);
  }

  .rs-header-title {
    margin: 3px 0 0;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    line-height: normal;
  }

  .rs-close-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: none;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.14);
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.2s ease;
  }

  .rs-close-btn ion-icon {
    font-size: 22px;
    color: #fff;
  }

  .rs-close-btn:hover,
  .rs-close-btn:focus {
    background: rgba(255, 255, 255, 0.26);
    outline: none;
  }

  /* ── Body ───────────────────────────────────────────────── */
  .rs-dialog-body {
    padding: 14px 14px 6px !important;
    min-height: 80px;
    max-height: 320px;
    background: linear-gradient(180deg, var(--ion-color-secondary) 0%, var(--ion-color-primary-tint) 100%);
  }

  /* ── Hint ───────────────────────────────────────────────── */
  .rs-hint-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    margin-bottom: 12px;
    border-radius: 12px;
    border: 1px solid var(--ion-color-light-tint);
    background: var(--ion-color-secondary);
    font-size: 12.5px;
    color: var(--ion-color-primary-contrast);
    line-height: 1.5;
  }

  .rs-hint-row ion-icon {
    font-size: 17px;
    color: var(--ion-color-secondary-shade);
    flex-shrink: 0;
  }

  /* ── Search ────────────────────────────────────────────── */
  .rs-search-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    margin-bottom: 12px;
    border-radius: 12px;
    border: 1.5px solid var(--ion-color-light-tint);
    background: var(--ion-color-secondary);
    box-shadow: 0 3px 8px var(--ion-color-secondary-contrast);
    transition: border-color 0.18s ease;
  }

  .rs-search-wrap:focus-within {
    border-color: var(--ion-color-secondary-shade);
  }

  .rs-search-icon-box {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  .rs-search-icon-box ion-icon {
    font-size: 18px;
    color: var(--ion-color-primary-contrast);
  }

  .rs-search-input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    color: var(--ion-color-secondary-shade);
    min-width: 0;
  }

  .rs-search-input::placeholder {
    color: #aab4be;
  }

  .rs-search-clear {
    display: flex;
    align-items: center;
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
  }

  .rs-search-clear ion-icon {
    font-size: 18px;
    color: #aab4be;
  }

  .rs-search-clear:hover ion-icon {
    color: var(--ion-color-secondary-shade);
  }

  .rs-no-results {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 24px 16px;
    color: var(--ion-color-primary-contrast);
    font-size: 13px;
  }

  .rs-no-results ion-icon {
    font-size: 32px;
    color: #c8d0d8;
  }

  /* ── Response List ──────────────────────────────────────── */
  .rs-response-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .rs-response-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 14px;
    border: 1.5px solid var(--ion-color-light-tint);
    background: var(--ion-color-secondary);
    cursor: pointer;
    transition: border-color 0.18s ease, background 0.18s ease, transform 0.15s ease;
    box-shadow: 0 4px 10px var(--ion-color-secondary-contrast);
  }

  .rs-response-item:hover {
    background: var(--ion-color-primary-tint);
    transform: translateY(-1px);
  }

  .rs-response-item.rs-item--selected {
    border-color: var(--ion-color-secondary-shade);
    background: linear-gradient(135deg, var(--ion-color-secondary) 0%, var(--ion-color-primary-tint) 100%);
    box-shadow: 0 6px 14px var(--ion-color-secondary-contrast);
  }

  .rs-item-icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 9px;
    background: var(--ion-color-primary-tint);
    border: 1px solid var(--ion-color-light-tint);
    flex-shrink: 0;
    transition: background 0.18s ease;
  }

  .rs-response-item.rs-item--selected .rs-item-icon-box {
    background: var(--ion-color-secondary-shade);
    border-color: var(--ion-color-secondary-shade);
  }

  .rs-item-icon-box ion-icon {
    font-size: 16px;
    color: var(--ion-color-secondary-shade);
    transition: color 0.18s ease;
  }

  .rs-response-item.rs-item--selected .rs-item-icon-box ion-icon {
    color: #fff;
  }

  .rs-item-label {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: var(--ion-color-secondary-shade);
    line-height: 1.3;
  }

  .rs-item-checkbox {
    --checkbox-background-checked: var(--ion-color-secondary-shade);
    --border-color: #aab4be;
    --border-color-checked: var(--ion-color-secondary-shade);
    --border-radius: 5px;
    --size: 18px;
    pointer-events: none;
  }

  /* ── Footer ─────────────────────────────────────────────── */
  .rs-dialog-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 12px 16px;
    border-top: 1px solid var(--ion-color-light-tint);
    background: var(--ion-color-secondary);
    flex-wrap: wrap;
  }

  .rs-custom-list-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border-radius: 20px;
    border: 1px solid var(--ion-color-secondary-shade);
    background: transparent;
    color: var(--ion-color-secondary-shade);
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s ease, color 0.2s ease;
  }

  .rs-custom-list-pill ion-icon {
    font-size: 15px;
  }

  .rs-custom-list-pill:hover {
    background: var(--ion-color-secondary-shade);
    color: #fff;
  }

  .rs-footer-actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .rs-btn-cancel {
    --background: transparent;
    --border-color: var(--ion-color-secondary-shade);
    --color: var(--ion-color-secondary-shade);
    --box-shadow: none;
    --border-radius: 12px;
    --border-width: 1px;
    --border-style: solid;
  }

  .rs-btn-save {
    --background: var(--ion-color-secondary-shade);
    --color: #fff;
    --box-shadow: 0 6px 16px var(--ion-color-secondary-contrast);
    --border-radius: 12px;
  }

  .rs-btn-save[disabled] {
    opacity: 0.45;
  }
</style>

